import { createFileRoute } from "@tanstack/react-router";
import Articles from "@/pages/Articles";

export const Route = createFileRoute("/artigos/")({
  component: Articles,
});